export interface RatingReason {
  id: number;
  name: string;
  sf_value: string;
  tooltip: string;
  active: boolean;
  parent_id: string;
  picklist_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string;
  children: RatingReason[];
  selected?: boolean;
  customIdHtml?: string;
}
